// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as BulkReasonApiModel from "../api-model/BulkReasonApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeResonType(data) {
  return List.map((function (reason) {
                return {
                        id: reason.id,
                        reason: reason.reason,
                        reason_enum: reason.reason_enum,
                        is_bulk_txn_allowed: reason.is_bulk_txn_allowed
                      };
              }), data);
}

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(BulkReasonApiModel.res_decode(json), "BulkReasonEntityMapper.res").reason;
  return {
          credit: decodeResonType(model.credit),
          debit: decodeResonType(model.debit)
        };
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
